import Branch from "../../models/Branch.ts";

/** Sucursal del reloj tomada de la sesión. No consulta el catálogo de sucursales. */
export function clockBranchFromSession(user?: {
  branchId?: number | null;
  branch?: string | null;
} | null): Branch | undefined {
  if (typeof user?.branchId !== "number") {
    return undefined;
  }
  return new Branch(String(user.branchId), user.branch || "", "", "", "", "");
}
